import { request } from "../axios/request";

export const getAssetLocationService = (params = null) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/asset-locations", getState(), {
        method: "GET",
        params,
      })
    );
  };
};

export const getAllAssetLocationsService = (params = null) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/asset-locations", getState(), {
        method: "GET",
        params,
      })
    );
  };
};

export const saveAssetLocationService = (data, id = 0) => {
  if (id > 0) {
    return async (dispatch, getState) => {
      return dispatch(
        request("/asset-locations/" + id, getState(), {
          method: "PUT",
          data,
        })
      );
    };
  }
  return async (dispatch, getState) => {
    return dispatch(
      request("/asset-locations", getState(), {
        method: "POST",
        data,
      })
    );
  };
};

export const deleteAssetLocationService = (id = 0) => {
  return async (dispatch, getState) => {
    return dispatch(
      request("/asset-locations/" + id, getState(), {
        method: "DELETE",
      })
    );
  };
};
